// Static room administration vocabulary; operational data is never translated.
export const roomAdministrationResources = {
  en: {
    title: "Rooms & room types",
    selectHotel: "Select a hotel first.",
    rooms: "Rooms",
    types: "Room types",
    room: "Room",
    type: "Room type",
    addRoom: "Add room",
    addType: "Add room type",
    number: "Room number",
    floor: "Floor",
    name: "Name",
    base: "Base occupancy",
    max: "Maximum occupancy",
    description: "Description",
    amenities: "Amenities",
    commaSeparated: "Separate values with commas.",
    beds: "Beds",
    bedType: "Bed type",
    quantity: "Quantity",
    addBed: "Add bed configuration",
    remove: "Remove",
    actions: "Actions",
    status: "Status",
    roomStatus: "Room status / disable sales",
    edit: "Edit",
    save: "Save",
    saving: "Saving…",
    saved: "Saved. The change has been recorded in the audit log.",
    cancel: "Cancel",
    search: "Search",
    refresh: "Refresh",
    reload: "Discard draft and reload",
    loading: "Loading rooms and room types…",
    empty: "No matching records.",
    typeFirst: "Create a room type before adding rooms.",
    readOnly: "Read-only access. Editing requires settings.edit at this hotel.",
    forbidden: "You do not have permission to access or change this hotel's rooms.",
    error: "Could not load or save the room configuration. Please retry.",
    invalid: "Check all required fields, occupancy limits, bed quantities and the selected hotel.",
    conflict: "Someone changed this record. Discard the draft and reload before editing again.",
    duplicate: "This room number already exists in this hotel.",
    inUse: "Room type or occupancy changes are blocked because reservations or room blocks already use this configuration. Names and descriptions can still be edited.",
    structureHint: "Existing reservation and block history is protected. Type and occupancy changes may be refused for configurations already in use.",
    statusHint: "To disable or restore sales, use Room status and the existing Out of Service / Out of Order workflow. Rooms are not deleted, so reservation and billing history is preserved.",
  },
  de: {
    title: "Zimmer & Zimmertypen",
    selectHotel: "Zuerst ein Hotel auswählen.",
    rooms: "Zimmer",
    types: "Zimmertypen",
    room: "Zimmer",
    type: "Zimmertyp",
    addRoom: "Zimmer hinzufügen",
    addType: "Zimmertyp hinzufügen",
    number: "Zimmernummer",
    floor: "Etage",
    name: "Name",
    base: "Standardbelegung",
    max: "Maximalbelegung",
    description: "Beschreibung",
    amenities: "Ausstattung",
    commaSeparated: "Werte durch Kommas trennen.",
    beds: "Betten",
    bedType: "Bettentyp",
    quantity: "Anzahl",
    addBed: "Bettenkonfiguration hinzufügen",
    remove: "Entfernen",
    actions: "Aktionen",
    status: "Status",
    roomStatus: "Zimmerstatus / Verkauf sperren",
    edit: "Bearbeiten",
    save: "Speichern",
    saving: "Wird gespeichert…",
    saved: "Gespeichert. Die Änderung wurde protokolliert.",
    cancel: "Abbrechen",
    search: "Suchen",
    refresh: "Aktualisieren",
    reload: "Entwurf verwerfen und neu laden",
    loading: "Zimmer und Zimmertypen werden geladen…",
    empty: "Keine passenden Einträge.",
    typeFirst: "Vor dem ersten Zimmer einen Zimmertyp anlegen.",
    readOnly: "Nur Lesezugriff. Zum Bearbeiten ist settings.edit für dieses Hotel erforderlich.",
    forbidden: "Sie dürfen die Zimmer dieses Hotels nicht aufrufen oder ändern.",
    error: "Die Zimmerkonfiguration konnte nicht geladen oder gespeichert werden. Bitte erneut versuchen.",
    invalid: "Pflichtfelder, Belegungsgrenzen, Bettenanzahl und ausgewähltes Hotel prüfen.",
    conflict: "Dieser Eintrag wurde geändert. Den Entwurf verwerfen und vor der nächsten Bearbeitung neu laden.",
    duplicate: "Diese Zimmernummer existiert bereits in diesem Hotel.",
    inUse: "Änderungen am Zimmertyp oder an der Belegung sind gesperrt, da Reservierungen oder Zimmerkontingente diese Konfiguration verwenden. Namen und Beschreibungen bleiben bearbeitbar.",
    structureHint: "Bestehende Reservierungen und Kontingente bleiben geschützt. Typ- und Belegungsänderungen können bei bereits verwendeten Konfigurationen abgelehnt werden.",
    statusHint: "Zum Sperren oder Freigeben des Verkaufs den Zimmerstatus und den bestehenden Out-of-Service-/Out-of-Order-Ablauf verwenden. Zimmer werden nicht gelöscht; Reservierungs- und Rechnungshistorie bleiben erhalten.",
  },
  pl: {
    title: "Pokoje i typy pokoi",
    selectHotel: "Najpierw wybierz hotel.",
    rooms: "Pokoje",
    types: "Typy pokoi",
    room: "Pokój",
    type: "Typ pokoju",
    addRoom: "Dodaj pokój",
    addType: "Dodaj typ pokoju",
    number: "Numer pokoju",
    floor: "Piętro",
    name: "Nazwa",
    base: "Podstawowa liczba osób",
    max: "Maksymalna liczba osób",
    description: "Opis",
    amenities: "Udogodnienia",
    commaSeparated: "Oddziel wartości przecinkami.",
    beds: "Łóżka",
    bedType: "Typ łóżka",
    quantity: "Liczba",
    addBed: "Dodaj konfigurację łóżek",
    remove: "Usuń",
    actions: "Działania",
    status: "Status",
    roomStatus: "Status pokoju / wyłącz ze sprzedaży",
    edit: "Edytuj",
    save: "Zapisz",
    saving: "Zapisywanie…",
    saved: "Zapisano. Zmiana została zapisana w historii.",
    cancel: "Anuluj",
    search: "Szukaj",
    refresh: "Odśwież",
    reload: "Odrzuć formularz i wczytaj ponownie",
    loading: "Wczytywanie pokoi i ich typów…",
    empty: "Brak pasujących wpisów.",
    typeFirst: "Przed dodaniem pokoju utwórz jego typ.",
    readOnly: "Tylko podgląd. Edycja wymaga uprawnienia settings.edit w tym hotelu.",
    forbidden: "Nie masz uprawnień do podglądu lub edycji pokoi tego hotelu.",
    error: "Nie udało się wczytać lub zapisać konfiguracji pokoi. Spróbuj ponownie.",
    invalid: "Sprawdź wymagane pola, limity osób, liczbę łóżek i wybrany hotel.",
    conflict: "Ktoś zmienił ten wpis. Odrzuć formularz i wczytaj go ponownie przed kolejną edycją.",
    duplicate: "Taki numer pokoju już istnieje w tym hotelu.",
    inUse: "Nie można zmienić typu lub limitów osób, bo ta konfiguracja jest już używana przez rezerwacje lub bloki. Nadal możesz zmieniać nazwy i opisy.",
    structureHint: "Historia rezerwacji i bloków jest chroniona. Zmiana typu i limitów osób może być zablokowana dla używanej konfiguracji.",
    statusHint: "Aby wyłączyć lub przywrócić sprzedaż, użyj statusu pokoju i istniejącej blokady OOS/OOO. Nie usuwamy pokoi, więc historia rezerwacji i rozliczeń pozostaje zachowana.",
  },
} as const;
